/* eslint-disable max-lines */
const inputSchema = {
  'definitions': {},
  '$schema': 'http://json-schema.org/draft-07/schema#',
  '$id': 'http://example.com/root.json',
  'type': 'object',
  'title': 'The Root Schema',
  'required': [
    'type',
    'value'
  ],
  'properties': {
    'type': {
      '$id': '#/properties/type',
      'type': 'string',
      'title': 'The Type Schema',
      'default': '',
      'examples': [
        'input:text'
      ],
      'pattern': '^(.*)$'
    },
    'desc': {
      '$id': '#/properties/desc',
      'type': 'string',
      'title': 'The Desc Schema',
      'default': '',
      'examples': [
        '提示信息'
      ],
      'pattern': '^(.*)$'
    },
    'value': {
      '$id': '#/properties/value',
      'type': 'string',
      'title': 'The Value Schema',
      'default': '',
      'examples': [
        'value'
      ],
      'minLength': 0,
      'maxLength': 50,
      'pattern': '^(.*)$'
    }
  }
}

const inputNumberSchema = {
  'definitions': {},
  '$schema': 'http://json-schema.org/draft-07/schema#',
  '$id': 'http://example.com/root.json',
  'type': 'object',
  'title': 'The Root Schema',
  'required': [
    'type',
    'value'
  ],
  'properties': {
    'type': {
      '$id': '#/properties/type',
      'type': 'string',
      'title': 'The Type Schema',
      'default': '',
      'examples': [
        'input:number'
      ],
      'pattern': '^(.*)$'
    },
    'desc': {
      '$id': '#/properties/desc',
      'type': 'string',
      'title': 'The Desc Schema',
      'default': '',
      'examples': [
        '提示信息'
      ],
      'pattern': '^(.*)$'
    },
    'value': {
      '$id': '#/properties/value',
      'type': [
        'number',
        'integer',
        'string'
      ],
      'title': 'The Value Schema',
      'default': '',
      'examples': [
        'value'
      ],
      'pattern': '^(.*)$'
    },
    'min': {
      '$id': '#/properties/min',
      'type': [
        'number',
        'integer'
      ],
      'title': 'The Min Schema',
      'default': 0,
      'examples': [
        0
      ],
      'pattern': '^(.*)$'
    },
    'max': {
      '$id': '#/properties/max',
      'type': [
        'number',
        'integer'
      ],
      'title': 'The Max Schema',
      'default': 100,
      'examples': [
        100
      ],
      'pattern': '^(.*)$'
    },
    'step': {
      '$id': '#/properties/step',
      'type': [
        'number',
        'integer'
      ],
      'title': 'The Step Schema',
      'default': 1,
      'examples': [
        1
      ],
      'pattern': '^(.*)$'
    },
    'step-strictly': {
      '$id': '#/properties/step-strictly',
      'type': 'boolean',
      'title': 'The Step Strictly Schema',
      'default': false,
      'examples': [
        true
      ],
      'pattern': '^(.*)$'
    },
    'precision': {
      '$id': '#/properties/precision',
      'type': [
        'number',
        'integer'
      ],
      'title': 'The Precision Schema',
      'default': 1,
      'examples': [
        1
      ],
      'pattern': '^(.*)$'
    },
    'controls': {
      '$id': '#/properties/controls',
      'type': 'boolean',
      'title': 'The Controls Schema',
      'default': true,
      'examples': [
        true
      ],
      'pattern': '^(.*)$'
    },
    'controls-position': {
      '$id': '#/properties/controls-position',
      'type': 'string',
      'title': 'The Controls Position Schema',
      'default': 'right',
      'examples': [
        'right'
      ],
      'pattern': '^(.*)$'
    }
  }
}

const radioSchema = {
  'definitions': {},
  '$schema': 'http://json-schema.org/draft-07/schema#',
  '$id': 'http://example.com/root.json',
  'type': 'object',
  'title': 'The Root Schema',
  'required': [
    'type',
    'value',
    'options'
  ],
  'properties': {
    'type': {
      '$id': '#/properties/type',
      'type': 'string',
      'title': 'The Type Schema',
      'default': '',
      'examples': [
        'radio'
      ],
      'pattern': '^(.*)$'
    },
    'value': {
      '$id': '#/properties/value',
      'type': [
        'string',
        'number',
        'integer'
      ],
      'title': 'The Value Schema',
      'default': '',
      'examples': [
        'a'
      ],
      'pattern': '^(.*)$'
    },
    'options': {
      '$id': '#/properties/options',
      'type': 'array',
      'title': 'The Options Schema',
      'items': {
        '$id': '#/properties/options/items',
        'type': [
          'string',
          'number',
          'integer',
          'object'
        ],
        'title': 'The Items Schema',
        'default': '',
        'examples': [
          'a',
          'b',
          'c',
          'd'
        ],
        'pattern': '^(.*)$'
      }
    },
    'desc': {
      '$id': '#/properties/desc',
      'type': 'string',
      'title': 'The Desc Schema',
      'default': '',
      'examples': [
        '提示信息'
      ],
      'pattern': '^(.*)$'
    }
  }
}

const checkboxSchema = {
  'definitions': {},
  '$schema': 'http://json-schema.org/draft-07/schema#',
  '$id': 'http://example.com/root.json',
  'type': 'object',
  'title': 'The Root Schema',
  'required': [
    'type',
    'value',
    'options'
  ],
  'properties': {
    'type': {
      '$id': '#/properties/type',
      'type': 'string',
      'title': 'The Type Schema',
      'default': '',
      'examples': [
        'checkbox'
      ],
      'pattern': '^(.*)$'
    },
    'value': {
      '$id': '#/properties/value',
      'type': 'array',
      'title': 'The Value Schema',
      'items': {
        '$id': '#/properties/value/items',
        'type': [
          'string',
          'number',
          'integer'
        ],
        'title': 'The Items Schema',
        'default': '',
        'examples': [
          'a',
          'd'
        ],
        'pattern': '^(.*)$'
      }
    },
    'options': {
      '$id': '#/properties/options',
      'type': 'array',
      'title': 'The Options Schema',
      'items': {
        '$id': '#/properties/options/items',
        'type': [
          'string',
          'number',
          'integer',
          'object'
        ],
        'title': 'The Items Schema',
        'default': '',
        'examples': [
          'a',
          'b',
          'c',
          'd'
        ],
        'pattern': '^(.*)$'
      }
    },
    'desc': {
      '$id': '#/properties/desc',
      'type': 'string',
      'title': 'The Desc Schema',
      'default': '',
      'examples': [
        '提示信息'
      ],
      'pattern': '^(.*)$'
    }
  }
}

const switchSchema = {
  'definitions': {},
  '$schema': 'http://json-schema.org/draft-07/schema#',
  '$id': 'http://example.com/root.json',
  'type': 'object',
  'title': 'The Root Schema',
  'required': [
    'type',
    'value'
  ],
  'properties': {
    'type': {
      '$id': '#/properties/type',
      'type': 'string',
      'title': 'The Type Schema',
      'default': '',
      'examples': [
        'switch'
      ],
      'pattern': '^(.*)$'
    },
    'value': {
      '$id': '#/properties/value',
      'type': 'boolean',
      'title': 'The Value Schema',
      'default': false,
      'examples': [
        true
      ]
    },
    'desc': {
      '$id': '#/properties/desc',
      'type': 'string',
      'title': 'The Desc Schema',
      'default': '',
      'examples': [
        '提示信息'
      ],
      'pattern': '^(.*)$'
    }
  }
}

const schema = {
  namespaced: true,

  state: {
    slider: {
      'definitions': {},
      '$schema': 'http://json-schema.org/draft-07/schema#',
      '$id': 'http://example.com/root.json',
      'type': 'object',
      'title': 'The Root Schema',
      'required': [
        'type',
        'min',
        'max',
        'value'
      ],
      'properties': {
        'type': {
          '$id': '#/properties/type',
          'type': 'string',
          'title': 'The Type Schema',
          'default': '',
          'examples': [
            'slider'
          ],
          'pattern': '^(.*)$'
        },
        'min': {
          '$id': '#/properties/min',
          'type': [
            'number',
            'integer'
          ],
          'title': 'The Min Schema',
          'default': 0,
          'examples': [
            0
          ]
        },
        'max': {
          '$id': '#/properties/max',
          'type': [
            'number',
            'integer'
          ],
          'title': 'The Max Schema',
          'default': 0,
          'examples': [
            10
          ]
        },
        'desc': {
          '$id': '#/properties/desc',
          'type': 'string',
          'title': 'The Desc Schema',
          'default': '',
          'examples': [
            '提示信息'
          ],
          'pattern': '^(.*)$'
        },
        'value': {
          '$id': '#/properties/value',
          'type': [
            'number',
            'integer',
            'array'
          ],
          'title': 'The Value Schema',
          'default': 0,
          'examples': [
            4
          ]
        }
      }
    },
    'input:text': inputSchema,
    'input:number': inputNumberSchema,
    input: inputSchema,
    switch: switchSchema,
    radio: radioSchema,
    checkbox: checkboxSchema,
    array: {
      slider: {
        'definitions': {},
        '$schema': 'http://json-schema.org/draft-07/schema#',
        '$id': 'http://example.com/root.json',
        'type': 'object',
        'title': 'The Root Schema',
        'required': [
          'type',
          'subtype',
          'min',
          'max',
          'value'
        ],
        'properties': {
          'type': {
            '$id': '#/properties/type',
            'type': 'string',
            'title': 'The Type Schema',
            'default': '',
            'examples': [
              'array'
            ],
            'pattern': '^(.*)$'
          },
          'subtype': {
            '$id': '#/properties/subtype',
            'type': 'string',
            'title': 'The Subtype Schema',
            'default': '',
            'examples': [
              'slider'
            ],
            'pattern': '^(.*)$'
          },
          'min': {
            '$id': '#/properties/min',
            'type': [
              'number',
              'integer'
            ],
            'title': 'The Min Schema',
            'default': 0,
            'examples': [
              0
            ]
          },
          'max': {
            '$id': '#/properties/max',
            'type': [
              'number',
              'integer'
            ],
            'title': 'The Max Schema',
            'default': 0,
            'examples': [
              10
            ]
          },
          'desc': {
            '$id': '#/properties/desc',
            'type': 'string',
            'title': 'The Desc Schema',
            'default': '',
            'examples': [
              '提示信息{{i}}'
            ],
            'pattern': '^(.*)$'
          },
          'value': {
            '$id': '#/properties/value',
            'type': 'array',
            'title': 'The Value Schema',
            'items': {
              '$id': '#/properties/value/items',
              'type': [
                'number',
                'integer',
                'array'
              ],
              'title': 'The Items Schema',
              'default': 0,
              'examples': [
                1,
                2,
                3
              ]
            }
          },
          'itemsDesc': {
            '$id': '#/properties/itemsDesc',
            'type': 'array',
            'title': 'The Itemsdesc Schema',
            'default': null,
            'items': {
              '$id': '#/properties/itemsDesc/items',
              'type': 'string',
              'title': 'The Items Schema',
              'default': '',
              'examples': [
                '第一条描述',
                '第二条描述',
                '第三条描述'
              ],
              'pattern': '^(.*)$'
            }
          }
        }
      },
      'input:text': {
        'definitions': {},
        '$schema': 'http://json-schema.org/draft-07/schema#',
        '$id': 'http://example.com/root.json',
        'type': 'object',
        'title': 'The Root Schema',
        'required': [
          'type',
          'subtype',
          'value'
        ],
        'properties': {
          'type': {
            '$id': '#/properties/type',
            'type': 'string',
            'title': 'The Type Schema',
            'default': '',
            'examples': [
              'array'
            ],
            'pattern': '^(.*)$'
          },
          'subtype': {
            '$id': '#/properties/subtype',
            'type': 'string',
            'title': 'The Subtype Schema',
            'default': '',
            'examples': [
              'input:text'
            ],
            'pattern': '^(.*)$'
          },
          'desc': {
            '$id': '#/properties/desc',
            'type': 'string',
            'title': 'The Desc Schema',
            'default': '',
            'examples': [
              '提示信息'
            ],
            'pattern': '^(.*)$'
          },
          'value': {
            '$id': '#/properties/value',
            'type': 'array',
            'title': 'The Value Schema',
            'items': {
              '$id': '#/properties/value/items',
              'type': 'string',
              'title': 'The Items Schema',
              'default': '',
              'examples': [
                'a',
                'b',
                'c'
              ],
              'minLength': 0,
              'maxLength': 50,
              'pattern': '^(.*)$'
            }
          },
          'itemsDesc': {
            '$id': '#/properties/itemsDesc',
            'type': 'array',
            'title': 'The Itemsdesc Schema',
            'default': null,
            'items': {
              '$id': '#/properties/itemsDesc/items',
              'type': 'string',
              'title': 'The Items Schema',
              'default': '',
              'examples': [
                '第一条描述',
                '第二条描述',
                '第三条描述'
              ],
              'pattern': '^(.*)$'
            }
          }
        }
      }
    },
    select: {
      '$schema': 'http://json-schema.org/draft-07/schema',
      '$id': 'http://example.com/example.json',
      'type': 'object',
      'title': 'The root schema',
      'default': {},
      'examples': [
        {
          'type': 'select',
          'value': [
            'b',
            'c'
          ],
          'options': [
            'a',
            'b',
            'c',
            'd'
          ],
          'minItems': 2,
          'maxItems': 4,
          'addable': true,
          'removable': true,
          'unique': false,
          'desc': '描述'
        }
      ],
      'required': [
        'type',
        'value',
        'options'
      ],
      'properties': {
        'type': {
          '$id': '#/properties/type',
          'type': 'string',
          'title': 'The type schema',
          'default': '',
          'examples': [
            'select'
          ],
          'pattern': '^(.*)$'
        },
        'value': {
          '$id': '#/properties/value',
          'type': 'array',
          'title': 'The Value Schema',
          'items': {
            '$id': '#/properties/value/items',
            'type': [
              'string',
              'number',
              'integer'
            ],
            'title': 'The Items Schema',
            'default': '',
            'examples': [
              'a',
              'd'
            ],
            'pattern': '^(.*)$'
          }
        },
        'options': {
          '$id': '#/properties/options',
          'type': 'array',
          'title': 'The Options Schema',
          'items': {
            '$id': '#/properties/options/items',
            'type': [
              'string',
              'number',
              'integer',
              'object'
            ],
            'title': 'The Items Schema',
            'default': '',
            'examples': [
              'a',
              'b',
              'c',
              'd'
            ],
            'pattern': '^(.*)$'
          }
        },
        'minItems': {
          '$id': '#/properties/minItems',
          'type': 'integer',
          'title': 'The minItems schema',
          'description': 'An explanation about the purpose of this instance.',
          'default': 0,
          'examples': [
            2
          ]
        },
        'maxItems': {
          '$id': '#/properties/maxItems',
          'type': 'integer',
          'title': 'The maxItems schema',
          'description': 'An explanation about the purpose of this instance.',
          'default': 0,
          'examples': [
            4
          ]
        },
        'addable': {
          '$id': '#/properties/addable',
          'type': 'boolean',
          'title': 'The addable schema',
          'description': 'An explanation about the purpose of this instance.',
          'default': true,
          'examples': [
            true
          ]
        },
        'removable': {
          '$id': '#/properties/removable',
          'type': 'boolean',
          'title': 'The removable schema',
          'description': 'An explanation about the purpose of this instance.',
          'default': true,
          'examples': [
            true
          ]
        },
        'unique': {
          '$id': '#/properties/unique',
          'type': 'boolean',
          'title': 'The unique schema',
          'description': 'An explanation about the purpose of this instance.',
          'default': false,
          'examples': [
            false
          ]
        },
        'desc': {
          '$id': '#/properties/desc',
          'type': 'string',
          'title': 'The desc schema',
          'description': 'An explanation about the purpose of this instance.',
          'default': '',
          'examples': [
            '描述'
          ],
          'pattern': '^(.*)$'
        }
      }
    }
  },

  mutations: {},

  actions: {}
}

export default schema
